import uniqueId from 'lodash/uniqueId';
import sideElementFactory from '../elements/side-element';
import actionFactory from '../props/action';
import paddingModifier from '../props/padding-modifier';
import textProp from '../props/text';
import textStyle, { TEXT_STYLE } from '../props/text-style';
import numberHelper from '../props/number-helper';
import { getTextWeight } from '../../util';

/**
 * Парсер блока div-universal-block
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-universal-block.json
 * @param  {Object} block
 * @return {Object}
 */
export default (function (block) {
    var sideElement = sideElementFactory(block.side_element);
    var text = textProp(block.text);
    var textMaxLines = numberHelper(block.text_max_lines);
    var title = textProp(block.title);
    var titleMaxLines = numberHelper(block.title_max_lines);
    var weight = Math.max(getTextWeight(title, titleMaxLines) + getTextWeight(text, textMaxLines), sideElement ? sideElement.weight : 0);

    return {
        sideElement: sideElement,
        title: title,
        titleMaxLines: titleMaxLines,
        titleStyle: textStyle(block.title_style, TEXT_STYLE.titleS),
        text: text,
        textMaxLines: textMaxLines,
        textStyle: textStyle(block.text_style, TEXT_STYLE.textS),
        action: actionFactory(block),
        paddingModifier: paddingModifier(block),
        type: block.type,
        id: uniqueId('block_'),
        weight: weight
    };
});